// import React, { useState } from 'react'
// import Layout from '../components/layout'
// import { SiLimesurvey } from "react-icons/si";
// import { HiOutlineRocketLaunch } from "react-icons/hi2";
// import { RiSurveyLine } from "react-icons/ri";
// import { Line } from 'react-chartjs-2';
// import { VscCommentUnresolved } from "react-icons/vsc";
// import { TbCalendarDue } from "react-icons/tb";
// import { CgCalendarDue } from "react-icons/cg";
// import { FaRegEnvelopeOpen } from "react-icons/fa6";
// import { MdOutlinePendingActions } from "react-icons/md";
// import { MdAssignmentLate } from "react-icons/md";


// import {
//     Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
// } from "chart.js";
// import { useUser } from '../config/userProvider';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title);



// function Dashboard() {
//     const { userData, token } = useUser();

//     const [dashboardData, setDashboardData] = useState("a");

//     const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
//     const [activeTab, setActiveTab] = useState("whatsapp");

//     // console.log("userData",userData)


//     const data = {
//         labels,
//         datasets: [
//             {
//                 label: 'Dataset 1',
//                 data: labels.map(() => Math.random({ min: -1000, max: 1000 })),
//                 borderColor: 'rgb(255, 99, 132)',
//                 backgroundColor: 'rgba(255, 99, 132, 0.5)',
//             },
//             {
//                 label: 'Dataset 2',
//                 data: labels.map(() => Math.random({ min: -1000, max: 1000 })),

//                 //   data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
//                 borderColor: 'rgb(53, 162, 235)',
//                 backgroundColor: 'rgba(53, 162, 235, 0.5)',
//             },
//         ],
//     };

//     const appData = {
//         whatsapp: {
//             name: "WhatsApp",
//             description: "Business messaging via WhatsApp API",
//             price: "$49/month",
//             integrations: ["CRM", "Helpdesk", "Analytics"],
//             features: ["Bulk Messaging", "Chatbots", "Analytics"],
//             popularity: "95%"
//         },
//         telegram: {
//             name: "Telegram",
//             description: "Secure messaging platform integration",
//             price: "$39/month",
//             integrations: ["Bot Framework", "Analytics"],
//             features: ["Encrypted Chats", "Groups", "Channels"],
//             popularity: "85%"
//         },
//         infobip: {
//             name: "Infobip",
//             description: "Omnichannel communication platform",
//             price: "$59/month",
//             integrations: ["CRM", "Marketing Tools"],
//             features: ["SMS", "Voice", "Email"],
//             popularity: "90%"
//         },
//         wati: {
//             name: "Wati",
//             description: "WhatsApp team inbox solution",
//             price: "$45/month",
//             integrations: ["CRM", "E-commerce"],
//             features: ["Team Chat", "Automation", "Templates"],
//             popularity: "88%"
//         }
//     };

//     const TabContent = ({ app }) => (
//         <div className="p-6 flex-1">
//             <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-2xl font-bold text-primary">{app.name}</h2>
//                 <button className="bg-primary hover:bg-[#c7b89d] text-primary px-4 py-2 rounded-sm transition">
//                     Install Now
//                 </button>
//             </div>
//             <p className="text-primary mb-4 text-left">{app.description}</p>

//             <div className="bg-white rounded-sm p-4 shadow-sm border text-left border-gray-200">
//                 <h3 className="text-lg font-semibold text-primary mb-2">Pricing</h3>
//                 <p className="text-xl text-primary font-bold">{app.price}</p>

//                 <h3 className="text-lg font-semibold text-primary mt-4 mb-2">Integrations</h3>
//                 <div className="flex gap-2 flex-wrap">
//                     {app.integrations.map((integration, index) => (
//                         <span key={index} className="bg-gray-200 text-primary px-2 py-1 rounded-sm text-sm">
//                             {integration}
//                         </span>
//                     ))}
//                 </div>

//                 <h3 className="text-lg font-semibold text-primary mt-4 mb-2">Key Features</h3>
//                 <ul className="list-disc pl-5 text-primary">
//                     {app.features.map((feature, index) => (
//                         <li key={index}>{feature}</li>
//                     ))}
//                 </ul>

//                 <h3 className="text-lg font-semibold text-primary mt-4 mb-2">Additional Details</h3>
//                 <p className="text-primary">Popularity: {app.popularity} of businesses recommend</p>
//                 <p className="text-primary">Support: 24/7 Customer Support</p>
//                 <p className="text-primary">Setup: Quick 5-minute installation</p>
//             </div>
//         </div>
//     );

//     return (
//         <Layout>
//             <div className='h-full overflow-scroll hide-scrollbar'>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-2 px-5 py-8">
//                     {dashboardData ?
//                         <div className="shadow-sm  bg-[#fffdfc] rounded-sm p-5 border border-gray-50">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <VscCommentUnresolved />
//                                     </div>

//                                     <div className=" text-base text-primary font-medium">Unresolved</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">
//                                     55
//                                 </p>
//                                 {/* <p className="text-gray-600 text-sm">Last Month Total 1,050</p> */}
//                             </div>
//                         </div>
//                         :
//                         <div role="status" class="shadow-md rounded-sm p-5 animate-pulse">
//                             <div class="flex items-center justify-between">
//                                 <div class="flex items-center gap-4">
//                                     <div class="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div class="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div class="flex items-center justify-between mt-6">
//                                 <div class="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>

//                         // <surveyDetailsCardSkeleton />
//                     }



//                     {dashboardData ?
//                         <div className="shadow-sm  bg-[#fffdfc] rounded-sm p-5 border border-gray-50">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <TbCalendarDue />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Overdue</div>
//                                 </div>

//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">
//                                     4                                </p>
//                                 {/* <p className="text-gray-600 text-sm">Last Month Total 1.050</p> */}
//                             </div>
//                         </div>
//                         :
//                         <div role="status" class="shadow-md rounded-sm p-5 animate-pulse">
//                             <div class="flex items-center justify-between">
//                                 <div class="flex items-center gap-4">
//                                     <div class="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div class="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div class="flex items-center justify-between mt-6">
//                                 <div class="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     }
//                     {dashboardData ?
//                         <div className="shadow-sm  bg-[#fffdfc] rounded-sm p-5 border border-gray-50">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <CgCalendarDue />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">
//                                         Due Today
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">
//                                     11                                </p>
//                             </div>
//                         </div>
//                         :
//                         <div role="status" class="shadow-md rounded-sm p-5 animate-pulse">
//                             <div class="flex items-center justify-between">
//                                 <div class="flex items-center gap-4">
//                                     <div class="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div class="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div class="flex items-center justify-between mt-6">
//                                 <div class="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     }
//                     {dashboardData ?
//                         <div className="shadow-sm  bg-[#fffdfc] rounded-sm p-5 border border-gray-50">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <FaRegEnvelopeOpen />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Open</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">
//                                     28                                </p>
//                             </div>
//                         </div>
//                         :
//                         <div role="status" class="shadow-md rounded-sm p-5 animate-pulse">
//                             <div class="flex items-center justify-between">
//                                 <div class="flex items-center gap-4">
//                                     <div class="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div class="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div class="flex items-center justify-between mt-6">
//                                 <div class="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     }
//                     {dashboardData ?
//                         <div className="shadow-sm  bg-[#fffdfc] rounded-sm p-5 border border-gray-50">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <MdOutlinePendingActions />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">On hold</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">
//                                     3                                </p>
//                             </div>
//                         </div>
//                         :
//                         <div role="status" class="shadow-md rounded-sm p-5 animate-pulse">
//                             <div class="flex items-center justify-between">
//                                 <div class="flex items-center gap-4">
//                                     <div class="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div class="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div class="flex items-center justify-between mt-6">
//                                 <div class="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     }
//                     {dashboardData ?
//                         <div className="shadow-sm  bg-[#fffdfc] rounded-sm p-5 border border-gray-50">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <MdAssignmentLate />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Unassigned</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">
//                                     8                                </p>
//                             </div>
//                         </div>
//                         :
//                         <div role="status" class="shadow-md rounded-sm p-5 animate-pulse">
//                             <div class="flex items-center justify-between">
//                                 <div class="flex items-center gap-4">
//                                     <div class="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div class="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div class="flex items-center justify-between mt-6">
//                                 <div class="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     }
//                 </div>
//                 {/* <div className="p-5">
//                     <Line data={data} />
//                 </div> */}
//                 {/* Tabbed Section */}
//                 <div className="px-5 pb-8 flex gap-6">
//                     {/* Left Side - Tabs */}
//                     <div className="w-1/4 bg-white rounded-sm shadow-sm p-4 border border-gray-200">
//                         {Object.keys(appData).map((tab) => (
//                             <button
//                                 key={tab}
//                                 className={`w-full text-left px-4 py-2 mb-2 rounded-sm transition ${activeTab === tab
//                                         ? 'bg-primary text-primary'
//                                         : 'bg-gray-100 text-primary hover:bg-gray-200'
//                                     }`}
//                                 onClick={() => setActiveTab(tab)}
//                             >
//                                 {appData[tab].name}
//                             </button>
//                         ))}
//                     </div>

//                     {/* Right Side - Content */}
//                     <TabContent app={appData[activeTab]} />
//                 </div>
//             </div>
//         </Layout>
//     )
// }

// export default Dashboard














// import React, { useState } from 'react'
// import Layout from '../components/layout'
// import { SiLimesurvey } from "react-icons/si";
// import { HiOutlineRocketLaunch } from "react-icons/hi2";
// import { RiSurveyLine } from "react-icons/ri";
// import { Line } from 'react-chartjs-2';
// import { VscCommentUnresolved } from "react-icons/vsc";
// import { TbCalendarDue } from "react-icons/tb";
// import { CgCalendarDue } from "react-icons/cg";
// import { FaRegEnvelopeOpen } from "react-icons/fa6";
// import { MdOutlinePendingActions } from "react-icons/md";
// import { MdAssignmentLate } from "react-icons/md";

// import {
//     Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
// } from "chart.js";
// import { useUser } from '../config/userProvider';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title);

// function Dashboard() {
//     const { userData, token } = useUser();
//     const [dashboardData, setDashboardData] = useState("a");
//     const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
//     const [activeTab, setActiveTab] = useState("whatsapp");

//     const data = {
//         labels,
//         datasets: [
//             {
//                 label: 'Dataset 1',
//                 data: labels.map(() => Math.random() * 2000 - 1000),
//                 borderColor: '#48BBF9', // Matches --light-primary-color
//                 backgroundColor: 'rgba(72, 187, 249, 0.5)', // Light primary with opacity
//             },
//             {
//                 label: 'Dataset 2',
//                 data: labels.map(() => Math.random() * 2000 - 1000),
//                 borderColor: '#1A5276', // Matches --primary-color
//                 backgroundColor: 'rgba(26, 82, 118, 0.5)', // Primary with opacity
//             },
//         ],
//     };

//     const appData = {
//         whatsapp: {
//             name: "WhatsApp",
//             description: "Business messaging via WhatsApp API",
//             price: "$49/month",
//             integrations: ["CRM", "Helpdesk", "Analytics"],
//             features: ["Bulk Messaging", "Chatbots", "Analytics"],
//             popularity: "95%"
//         },
//         telegram: {
//             name: "Telegram",
//             description: "Secure messaging platform integration",
//             price: "$39/month",
//             integrations: ["Bot Framework", "Analytics"],
//             features: ["Encrypted Chats", "Groups", "Channels"],
//             popularity: "85%"
//         },
//         infobip: {
//             name: "Infobip",
//             description: "Omnichannel communication platform",
//             price: "$59/month",
//             integrations: ["CRM", "Marketing Tools"],
//             features: ["SMS", "Voice", "Email"],
//             popularity: "90%"
//         },
//         wati: {
//             name: "Wati",
//             description: "WhatsApp team inbox solution",
//             price: "$45/month",
//             integrations: ["CRM", "E-commerce"],
//             features: ["Team Chat", "Automation", "Templates"],
//             popularity: "88%"
//         }
//     };

//     const TabContent = ({ app }) => (
//         <div className="p-6 flex-1">
//             <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-2xl font-bold text-primary">{app.name}</h2>
//                 <button className="bg-primary hover:bg-light-primary text-white px-4 py-2 rounded-sm transition">
//                     Install Now
//                 </button>
//             </div>
//             <p className="text-primary mb-4 text-left">{app.description}</p>

//             <div className="bg-white rounded-sm p-4 shadow-sm border border-light-secondary text-left">
//                 <h3 className="text-lg font-semibold text-primary mb-2">Pricing</h3>
//                 <p className="text-xl text-primary font-bold">{app.price}</p>

//                 <h3 className="text-lg font-semibold text-primary mt-4 mb-2">Integrations</h3>
//                 <div className="flex gap-2 flex-wrap">
//                     {app.integrations.map((integration, index) => (
//                         <span key={index} className="bg-light-secondary text-primary px-2 py-1 rounded-sm text-sm">
//                             {integration}
//                         </span>
//                     ))}
//                 </div>

//                 <h3 className="text-lg font-semibold text-primary mt-4 mb-2">Key Features</h3>
//                 <ul className="list-disc pl-5 text-primary">
//                     {app.features.map((feature, index) => (
//                         <li key={index}>{feature}</li>
//                     ))}
//                 </ul>

//                 <h3 className="text-lg font-semibold text-primary mt-4 mb-2">Additional Details</h3>
//                 <p className="text-primary">Popularity: {app.popularity} of businesses recommend</p>
//                 <p className="text-primary">Support: 24/7 Customer Support</p>
//                 <p className="text-primary">Setup: Quick 5-minute installation</p>
//             </div>
//         </div>
//     );

//     return (
//         <Layout>
//             <div className='h-full overflow-scroll hide-scrollbar bg-light-secondary'>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-2 px-5 py-8">
//                     {dashboardData ? (
//                         <div className="shadow-sm bg-secondary rounded-sm p-5 border border-light-secondary">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <VscCommentUnresolved />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Unresolved</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">55</p>
//                             </div>
//                         </div>
//                     ) : (
//                         <div role="status" className="shadow-md rounded-sm p-5 animate-pulse">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div className="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <div className="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     )}

//                     {dashboardData ? (
//                         <div className="shadow-sm bg-secondary rounded-sm p-5 border border-light-secondary">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <TbCalendarDue />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Overdue</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">4</p>
//                             </div>
//                         </div>
//                     ) : (
//                         <div role="status" className="shadow-md rounded-sm p-5 animate-pulse">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div className="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <div className="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     )}

//                     {dashboardData ? (
//                         <div className="shadow-sm bg-secondary rounded-sm p-5 border border-light-secondary">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <CgCalendarDue />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Due Today</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">11</p>
//                             </div>
//                         </div>
//                     ) : (
//                         <div role="status" className="shadow-md rounded-sm p-5 animate-pulse">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div className="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <div className="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     )}

//                     {dashboardData ? (
//                         <div className="shadow-sm bg-secondary rounded-sm p-5 border border-light-secondary">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <FaRegEnvelopeOpen />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Open</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">28</p>
//                             </div>
//                         </div>
//                     ) : (
//                         <div role="status" className="shadow-md rounded-sm p-5 animate-pulse">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div className="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <div className="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     )}

//                     {dashboardData ? (
//                         <div className="shadow-sm bg-secondary rounded-sm p-5 border border-light-secondary">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <MdOutlinePendingActions />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">On Hold</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">3</p>
//                             </div>
//                         </div>
//                     ) : (
//                         <div role="status" className="shadow-md rounded-sm p-5 animate-pulse">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div className="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <div className="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     )}

//                     {dashboardData ? (
//                         <div className="shadow-sm bg-secondary rounded-sm p-5 border border-light-secondary">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-primary/10 p-2 rounded-full text-primary border border-primary">
//                                         <MdAssignmentLate />
//                                     </div>
//                                     <div className="text-base text-primary font-medium">Unassigned</div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <p className="text-xl text-primary font-semibold">8</p>
//                             </div>
//                         </div>
//                     ) : (
//                         <div role="status" className="shadow-md rounded-sm p-5 animate-pulse">
//                             <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-4">
//                                     <div className="bg-gray-300 p-2 rounded-full h-10 w-10"></div>
//                                     <div class="bg-gray-300 h-5 w-32 rounded"></div>
//                                 </div>
//                             </div>
//                             <div className="flex items-center justify-between mt-6">
//                                 <div className="bg-gray-300 h-8 w-20 rounded"></div>
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* Tabbed Section */}
//                 <div className="px-5 pb-8 flex gap-6">
//                     {/* Left Side - Tabs */}
//                     <div className="w-1/4 bg-secondary rounded-sm shadow-sm p-4 border border-light-secondary">
//                         {Object.keys(appData).map((tab) => (
//                             <button
//                                 key={tab}
//                                 className={`w-full text-left px-4 py-2 mb-2 rounded-sm transition ${
//                                     activeTab === tab
//                                         ? 'bg-primary text-white'
//                                         : ' text-primary hover:bg-primary hover:text-white'
//                                 }`}
//                                 onClick={() => setActiveTab(tab)}
//                             >
//                                 {appData[tab].name}
//                             </button>
//                         ))}
//                     </div>

//                     {/* Right Side - Content */}
//                     <TabContent app={appData[activeTab]} />
//                 </div>

//                 {/* Uncomment if you want the chart back */}
//                 {/* <div className="p-5 bg-white rounded-sm shadow-sm border border-light-secondary mx-5 mb-8">
//                     <Line data={data} />
//                 </div> */}
//             </div>
//         </Layout>
//     )
// }

// export default Dashboard






















// import React, { useState } from 'react';
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
// } from 'chart.js';
// import { Line, Pie, Bar } from 'react-chartjs-2';
// import { VscCommentUnresolved } from 'react-icons/vsc'; // Visual Studio Code icons
// import { TbArrowBounce, TbCalendarDue } from 'react-icons/tb'; // Tabler Icons
// import { CgCalendarDue, CgLoadbar } from 'react-icons/cg'; // Css.gg icons
// import { FaArrowUp, FaCrown, FaEnvelope, FaRegEnvelopeOpen, FaRegFrown, FaRegSmile, FaTelegram, FaWallet, FaWhatsapp } from 'react-icons/fa'; // Font Awesome icons
// import { MdOutlinePendingActions, MdAssignmentLate, MdOutlineSupportAgent, MdOutlineShoppingBag, MdOutlineTimelapse } from 'react-icons/md'; // Material Design icons
// import Layout from '../components/layout';
// import { FiUsers } from 'react-icons/fi';
// import { HiOutlineMegaphone } from 'react-icons/hi2';
// import { RiCoupon3Line } from 'react-icons/ri';
// import { BiConversation } from 'react-icons/bi';
// import { IoIosSpeedometer, IoMdSend } from 'react-icons/io';
// import { BsCart3, BsCurrencyDollar } from 'react-icons/bs';
// import { AiOutlineShoppingCart } from 'react-icons/ai';
// import { GiTakeMyMoney } from 'react-icons/gi';
// import { RiBounceRateLine } from "react-icons/ri"; // Bounce rate
// import { PiFlowArrow } from 'react-icons/pi';
// import { AgCharts } from "ag-charts-react";
// import { topology } from "../config/topology";
// import { useUser } from "../config/userProvider";
// import "ag-charts-enterprise";

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title);

// const KPICard = ({ icon: Icon, title, value }) => (
//     <div className="bg-white p-5 rounded-sm shadow-md border border-[#48BBF9]/20">
//         <div className="flex items-center justify-between">
//             <div className="flex items-center gap-4">
//                 <div className="bg-[#1A5276]/10 p-2 rounded-full text-[#1A5276] border border-[#1A5276]">
//                     <Icon size={24} />
//                 </div>
//                 <div className="text-base text-[#1A5276] font-medium">{title}</div>
//             </div>
//         </div>
//         <div className="flex items-center justify-between mt-6">
//             <p className="text-xl text-[#1A5276] font-semibold">{value}</p>
//         </div>
//     </div>
// );

// const TabContent = ({ app }) => (
//     <div className="p-6 flex-1">
//         <div className="flex justify-between items-center mb-4">
//             <h2 className="text-2xl font-bold text-[#1A5276]">{app.name}</h2>
//             <button className="bg-[#1A5276] hover:bg-[#48BBF9] text-white px-4 py-2 rounded-sm transition">
//                 Install Now
//             </button>
//         </div>
//         <p className="text-[#1A5276] mb-4 text-left">{app.description}</p>
//         <div className="bg-white rounded-sm p-4 shadow-md border border-[#48BBF9]/20 text-left">
//             <h3 className="text-lg font-semibold text-[#1A5276] mb-2">Pricing</h3>
//             <p className="text-xl text-[#1A5276] font-bold">{app.price}</p>
//             <h3 className="text-lg font-semibold text-[#1A5276] mt-4 mb-2">Integrations</h3>
//             <div className="flex gap-2 flex-wrap">
//                 {app.integrations.map((integration, index) => (
//                     <span key={index} className="bg-[#48BBF9]/20 text-[#1A5276] px-2 py-1 rounded-sm text-sm">
//                         {integration}
//                     </span>
//                 ))}
//             </div>
//             <h3 className="text-lg font-semibold text-[#1A5276] mt-4 mb-2">Key Features</h3>
//             <ul className="list-disc pl-5 text-[#1A5276]">
//                 {app.features.map((feature, index) => (
//                     <li key={index}>{feature}</li>
//                 ))}
//             </ul>
//             <h3 className="text-lg font-semibold text-[#1A5276] mt-4 mb-2">Additional Details</h3>
//             <p className="text-[#1A5276]">Popularity: {app.popularity} of businesses recommend</p>
//             <p className="text-[#1A5276]">Support: 24/7 Customer Support</p>
//             <p className="text-[#1A5276]">Setup: Quick 5-minute installation</p>
//         </div>
//     </div>
// );




// function Dashboard() {
//     const [activeTab, setActiveTab] = useState('whatsapp');
//         const { userData, token } = useUser();



//     const data = [
//         { name: "Albania", value: 83.7 },
//         { name: "Algeria", value: 99.7 },
//         { name: "Andorra", value: 100 },
//         { name: "Angola", value: 50 },
//         { name: "Antigua and Barbuda", value: 100 },
//         { name: "Argentina", value: 99.9 },
//         { name: "Armenia", value: 98.4 },
//         { name: "Australia", value: 100 },
//         { name: "Austria", value: 100 },
//         { name: "Azerbaijan", value: 98.3 },
//         { name: "Bahamas", value: 100 },
//         { name: "Bahrain", value: 100 },
//         { name: "Bangladesh", value: 26.5 },
//         { name: "Barbados", value: 100 },
//         { name: "Belarus", value: 99.6 },
//         { name: "Belgium", value: 100 },
//         { name: "Belize", value: 83 },
//         { name: "Benin", value: 4.6 },
//         { name: "Bhutan", value: 87 },
//         { name: "Bolivia", value: 88.3 },
//         { name: "Bosnia and Herzegovina", value: 41.65 },
//         { name: "Botswana", value: 65.7 },
//         { name: "Brazil", value: 96.5 },
//         { name: "Brunei", value: 100 },
//         { name: "Burkina Faso", value: 11.7 },
//         { name: "Burundi", value: 0.2 },
//         { name: "Cape Verde", value: 81.8 },
//         { name: "Cambodia", value: 44.5 },
//         { name: "Cameroon", value: 22.8 },
//         { name: "Canada", value: 100 },
//         { name: "Central African Republic", value: 0.900000000000001 },
//         { name: "Chad", value: 8 },
//         { name: "Chile", value: 100 },
//         { name: "China", value: 83.2 },
//         { name: "Colombia", value: 93.3 },
//         { name: "Comoros", value: 11.3 },
//         { name: "Democratic Republic of The Congo", value: 4.3 },
//         { name: "Congo", value: 35.6 },
//         { name: "Costa Rica", value: 95.9 },
//         { name: "Ivory Coast", value: 31.7 },
//         { name: "Croatia", value: 100 },
//         { name: "Cuba", value: 94.3 },
//         { name: "Cyprus", value: 100 },
//         { name: "Czechia", value: 100 },
//         { name: "Denmark", value: 100 },
//         { name: "Djibouti", value: 9.6 },
//         { name: "Dominica", value: 89.4 },
//         { name: "Dominican Republic", value: 91.5 },
//         { name: "Ecuador", value: 94.7 },
//         { name: "Egypt", value: 99.9 },
//         { name: "El Salvador", value: 92.7 },
//         { name: "Equatorial Guinea", value: 24.1 },
//         { name: "Eritrea", value: 11.5 },
//         { name: "Estonia", value: 100 },
//         { name: "Eswatini", value: 58.1 },
//         { name: "Ethiopia", value: 7.5 },
//         { name: "Fiji", value: 51.4 },
//         { name: "Finland", value: 100 },
//         { name: "France", value: 100 },
//         { name: "Gabon", value: 89.7 },
//         { name: "Gambia", value: 1.7 },
//         { name: "Georgia", value: 90.6 },
//         { name: "Germany", value: 100 },
//         { name: "Ghana", value: 30.3 },
//         { name: "Greece", value: 100 },
//         { name: "Grenada", value: 88.3 },
//         { name: "Guatemala", value: 48.1 },
//         { name: "Guinea", value: 1 },
//         { name: "Guinea-Bissau", value: 1 },
//         { name: "Guyana", value: 82 },
//         { name: "Haiti", value: 4.3 },
//         { name: "Honduras", value: 49.5 },
//         { name: "Hungary", value: 100 },
//         { name: "Iceland", value: 100 },
//         { name: "India", value: 71.1 },
//         { name: "Indonesia", value: 86.9 },
//         { name: "Iran", value: 96.4 },
//         { name: "Iraq", value: 99.3 },
//         { name: "Ireland", value: 100 },
//         { name: "Israel", value: 100 },
//         { name: "Italy", value: 100 },
//         { name: "Jamaica", value: 82.5 },
//         { name: "Japan", value: 100 },
//         { name: "Jordan", value: 99.9 },
//         { name: "Kazakhstan", value: 93.9 },
//         { name: "Kenya", value: 23.9 },
//         { name: "Kiribati", value: 12.4 },
//         { name: "North Korea", value: 12.5 },
//         { name: "South Korea", value: 100 },
//         { name: "Kuwait", value: 100 },
//         { name: "Kyrgyzstan", value: 78.2 },
//         { name: "Laos", value: 9.3 },
//         { name: "Latvia", value: 100 },
//         { name: "Lesotho", value: 41.1 },
//         { name: "Liberia", value: 0.4 },
//         { name: "Lithuania", value: 100 },
//         { name: "Luxembourg", value: 100 },
//         { name: "Madagascar", value: 1.4 },
//         { name: "Malawi", value: 1.6 },
//         { name: "Malaysia", value: 93.8 },
//         { name: "Maldives", value: 99.5 },
//         { name: "Mali", value: 0.900000000000001 },
//         { name: "Malta", value: 100 },
//         { name: "Marshall Islands", value: 66.7 },
//         { name: "Mauritania", value: 48.3 },
//         { name: "Mauritius", value: 98.9 },
//         { name: "Mexico", value: 84.6 },
//         { name: "Micronesia", value: 13.3 },
//         { name: "Moldova", value: 97.6 },
//         { name: "Monaco", value: 100 },
//         { name: "Mongolia", value: 53 },
//         { name: "Montenegro", value: 62 },
//         { name: "Morocco", value: 98.2 },
//         { name: "Mozambique", value: 5.4 },
//         { name: "Namibia", value: 47.3 },
//         { name: "Nauru", value: 100 },
//         { name: "Nepal", value: 35.2 },
//         { name: "Netherlands", value: 100 },
//         { name: "New Zealand", value: 100 },
//         { name: "Nicaragua", value: 57.4 },
//         { name: "Niger", value: 3 },
//         { name: "Nigeria", value: 16.8 },
//         { name: "North Macedonia", value: 79.2 },
//         { name: "Norway", value: 100 },
//         { name: "Oman", value: 100 },
//         { name: "Pakistan", value: 50.7 },
//         { name: "Palau", value: 43 },
//         { name: "Panama", value: 100 },
//         { name: "Papua New Guinea", value: 9.7 },
//         { name: "Paraguay", value: 69.8 },
//         { name: "Peru", value: 85.5 },
//         { name: "Philippines", value: 48 },
//         { name: "Poland", value: 100 },
//         { name: "Portugal", value: 100 },
//         { name: "Qatar", value: 100 },
//         { name: "Romania", value: 100 },
//         { name: "Russian Federation", value: 72.9 },
//         { name: "Rwanda", value: 5.4 },
//         { name: "Samoa", value: 37.2 },
//         { name: "San Marino", value: 100 },
//         { name: "Saudi Arabia", value: 100 },
//         { name: "Senegal", value: 29.4 },
//         { name: "Serbia", value: 80.6 },
//         { name: "Seychelles", value: 100 },
//         { name: "Sierra Leone", value: 0.800000000000001 },
//         { name: "Singapore", value: 100 },
//         { name: "Slovakia", value: 100 },
//         { name: "Slovenia", value: 100 },
//         { name: "Solomon Islands", value: 8.9 },
//         { name: "Somalia", value: 3.8 },
//         { name: "South Africa", value: 88.4 },
//         { name: "South Sudan", value: 0 },
//         { name: "Spain", value: 100 },
//         { name: "Sri Lanka", value: 32.6 },
//         { name: "Sudan", value: 62.8 },
//         { name: "Suriname", value: 94.8 },
//         { name: "Sweden", value: 100 },
//         { name: "Switzerland", value: 100 },
//         { name: "Syria", value: 96.3 },
//         { name: "Tajikistan", value: 85.5 },
//         { name: "Thailand", value: 85.1 },
//         { name: "Timor-Leste", value: 15.2 },
//         { name: "Togo", value: 11.4 },
//         { name: "Tonga", value: 86.8 },
//         { name: "Trinidad and Tobago", value: 100 },
//         { name: "Tunisia", value: 99.9 },
//         { name: "Türkiye", value: 95.4 },
//         { name: "Turkmenistan", value: 99.9 },
//         { name: "Tuvalu", value: 74.6 },
//         { name: "Uganda", value: 0.700000000000001 },
//         { name: "Ukraine", value: 95.2 },
//         { name: "United Arab Emirates", value: 100 },
//         { name: "United Kingdom", value: 100 },
//         { name: "United States", value: 100 },
//         { name: "Uruguay", value: 100 },
//         { name: "Uzbekistan", value: 82.8 },
//         { name: "Vanuatu", value: 6.9 },
//         { name: "Venezuela", value: 95.5 },
//         { name: "Vietnam", value: 96.1 },
//         { name: "Yemen", value: 61.3 },
//         { name: "Zambia", value: 10.2 },
//         { name: "Zimbabwe", value: 30.3 },
//     ];


//     const [options, setOptions] = useState({
//         data,
//         topology,
//         series: [
//             {
//                 type: "map-shape-background",
//             },
//             {
//                 type: "map-shape",
//                 title: "Access to Clean Fuels",
//                 idKey: "name",
//                 colorKey: "value",
//                 colorName: "% of population",
//             },
//         ],
//         gradientLegend: {
//             enabled: true,
//             position: "right",
//             gradient: {
//                 preferredLength: 200,
//                 thickness: 2,
//             },
//             scale: {
//                 label: {
//                     fontSize: 10,
//                     formatter: (p) => p.value + "%",
//                 },
//             },
//         },
//     });


//     const appData = {
//         whatsapp: {
//             name: 'WhatsApp',
//             description: 'Business messaging via WhatsApp API',
//             price: '$49/month',
//             integrations: ['CRM', 'Helpdesk', 'Analytics'],
//             features: ['Bulk Messaging', 'Chatbots', 'Analytics'],
//             popularity: '95%',
//         },
//         telegram: {
//             name: 'Telegram',
//             description: 'Secure messaging platform integration',
//             price: '$39/month',
//             integrations: ['Bot Framework', 'Analytics'],
//             features: ['Encrypted Chats', 'Groups', 'Channels'],
//             popularity: '85%',
//         },
//         infobip: {
//             name: 'Infobip',
//             description: 'Omnichannel communication platform',
//             price: '$59/month',
//             integrations: ['CRM', 'Marketing Tools'],
//             features: ['SMS', 'Voice', 'Email'],
//             popularity: '90%',
//         },
//         wati: {
//             name: 'Wati',
//             description: 'WhatsApp team inbox solution',
//             price: '$45/month',
//             integrations: ['CRM', 'E-commerce'],
//             features: ['Team Chat', 'Automation', 'Templates'],
//             popularity: '88%',
//         },
//     };

//     const lineChartData = {
//         labels: ['Apr 1', 'Apr 2', 'Apr 3', 'Apr 4', 'Apr 5', 'Apr 6', 'Apr 7', 'Apr 8'],
//         datasets: [
//             {
//                 label: 'Conversations',
//                 data: [150, 170, 200, 180, 220, 230, 240, 245],
//                 borderColor: '#48BBF9',
//                 backgroundColor: 'rgba(72, 187, 249, 0.5)',
//             },
//         ],
//     };

//     const pieChartData = {
//         labels: ['Website', 'Mobile', 'WhatsApp'],
//         datasets: [
//             {
//                 data: [60, 25, 15],
//                 backgroundColor: ['#48BBF9', '#1A5276', '#A9A9A9'],
//             },
//         ],
//     };

//     const barChartData = {
//         labels: ['Order Status', 'Password Reset', 'Billing'],
//         datasets: [
//             {
//                 label: 'Query Count',
//                 data: [400, 300, 150],
//                 backgroundColor: '#1A5276',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: { legend: { position: 'top' } },
//     };

//     const unhandledQueries = [
//         { query: 'Refund Process', count: 45 },
//         { query: 'Store Hours', count: 30 },
//         { query: 'Payment Issues', count: 20 },
//     ];



//     // const UserCard = () => (
//     //     <div className="bg-white p-10 rounded-xl shadow-sm border border-accent flex flex-col md:flex-row gap-6 mb-6">

//     //         {/* Left Side - User Info */}
//     //         <div className="flex flex-col items-center gap-4 w-[50%]">
//     //             <div className="relative">
//     //                 <img
//     //                     src="https://stellar-signs.com/wp-content/uploads/2021/08/Depositphotos_13687440_s-2019.jpg"
//     //                     alt="Company Logo"
//     //                     className="w-20 h-20 rounded-full border-2 border-light-primary object-cover"
//     //                 />
//     //                 <div className="absolute -bottom-1 -right-1 bg-success text-white rounded-full p-1.5">
//     //                     <FaCrown className="text-xs" /> {/* Premium badge */}
//     //                 </div>
//     //             </div>
//     //             <div className="text-center">
//     //                 <h3 className="text-xl font-bold text-primary">Acme Corp</h3>
//     //                 <p className="text-secondary-text text-sm">john.doe@acmecorp.com</p>
//     //                 <p className="text-light-primary font-medium mt-1">Premium Plan</p>
//     //             </div>
//     //             <div className="flex gap-3">
//     //                 <FaWhatsapp className="text-success text-xl" />
//     //                 <FaTelegram className="text-light-primary text-xl" />
//     //             </div>
//     //         </div>

//     //         {/* Right Side - Wallet Card */}
//     //         <div className="flex-1 w-[50%]">
//     //             <div className="relative group">
//     //                 {/* Wallet Card (Gradient using your vars) */}
//     //                 <div className="bg-gradient-to-br from-primary to-light-primary p-5 rounded-xl shadow-lg text-white overflow-hidden">
//     //                     {/* Glossy overlay */}
//     //                     <div className="absolute top-0 left-0 w-full h-1/2 bg-white/10 rounded-t-xl"></div>

//     //                     {/* Card Chip */}
//     //                     <div className="flex items-start justify-between mb-6">
//     //                         <div className="bg-accent/40 w-10 h-8 rounded-sm flex items-center justify-center">
//     //                             <div className="bg-accent/80 w-6 h-5 rounded-sm"></div>
//     //                         </div>
//     //                         <FaWallet className="text-white/30 text-2xl" />
//     //                     </div>

//     //                     {/* Balance */}
//     //                     <div className="mb-6">
//     //                         <p className="text-xs opacity-80">Available Balance</p>
//     //                         <p className="text-3xl font-bold tracking-tight my-1">600</p>
//     //                         <p className="text-sm font-light">Loyalty Points</p>
//     //                     </div>

//     //                     {/* Card Footer */}
//     //                     <div className="flex justify-between items-center text-xs border-t border-white/20 pt-3">
//     //                         <span>Acme Corp</span>
//     //                         <span>●●●● ●●●●</span>
//     //                     </div>
//     //                 </div>

//     //                 {/* Floating Button (using error/success as accent) */}
//     //                 <button className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-white text-primary hover:bg-secondary font-semibold px-5 py-2 rounded-full shadow-lg transition-all flex items-center gap-1 group-hover:translate-y-0.5">
//     //                     <FaArrowUp className="text-xs" /> Upgrade
//     //                 </button>
//     //             </div>
//     //         </div>
//     //     </div>
//     // );


//     const UserCard = () => (
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-accent flex flex-col md:flex-row gap-6 items-stretch mb-6">

//             {/* Left Side - Compact User Info */}
//             <div className="flex-1 bg-secondary p-5 rounded-xl flex flex-col md:flex-row items-center gap-5">
//                 {/* Logo and Badge */}
//                 <div className="relative shrink-0">
//                     <img
//                         src="https://stellar-signs.com/wp-content/uploads/2021/08/Depositphotos_13687440_s-2019.jpg"
//                         alt="Company Logo"
//                         className="w-16 h-16 rounded-full border-2 border-light-primary object-cover"
//                     />
//                     <div className="absolute -bottom-1 -right-1 bg-success text-white rounded-full p-1.5">
//                         <FaCrown className="text-xs" />
//                     </div>
//                 </div>

//                 {/* User Details - Now in a tighter layout */}
//                 <div className="text-center md:text-left space-y-1">
//                     <h3 className="text-lg font-bold text-primary">Acme Corp</h3>
//                     <p className="text-secondary-text text-sm flex items-center gap-1 justify-center md:justify-start">
//                         <FaEnvelope className="text-light-primary" /> john.doe@acmecorp.com
//                     </p>
//                     <div className="flex items-center gap-2 justify-center md:justify-start">
//                         <span className="text-light-primary font-medium text-sm">Premium Plan</span>
//                         <div className="w-1 h-1 bg-secondary-text rounded-full"></div>
//                         <div className="flex gap-2">
//                             <FaWhatsapp className="text-success text-base" />
//                             <FaTelegram className="text-light-primary text-base" />
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Right Side - Wallet Card */}
//             <div className="flex-1">
//                 <div className="relative h-full">
//                     {/* Wallet Card */}
//                     <div className="bg-gradient-to-br from-primary to-light-primary p-5 rounded-xl shadow-lg text-white h-full flex flex-col justify-between">
//                         {/* Glossy overlay */}
//                         <div className="absolute top-0 left-0 w-full h-1/2 bg-white/10 rounded-t-xl"></div>

//                         {/* Top Row */}
//                         <div className="flex justify-between items-start z-10">
//                             <div className="bg-accent/40 w-10 h-8 rounded-sm flex items-center justify-center">
//                                 <div className="bg-accent/80 w-6 h-5 rounded-sm"></div>
//                             </div>
//                             <FaWallet className="text-white/30 text-2xl" />
//                         </div>

//                         {/* Middle Balance */}
//                         <div className="z-10 mb-5">
//                             <p className="text-xs opacity-80 mb-1">Available Balance</p>
//                             <p className="text-3xl font-bold tracking-tight">600</p>
//                             {/* <p className="text-sm font-light mt-1">Loyalty Points</p> */}
//                         </div>

//                         {/* Bottom Row */}
//                         <div className="flex justify-between items-center text-xs border-t border-white/20 pt-3 z-10">
//                             <span>Acme Corp</span>
//                             {/* <span>●●●● ●●●●</span> */}
//                             <button className="bg-white text-primary hover:bg-secondary font-semibold px-5 py-2 rounded-full shadow-lg transition-all flex items-center gap-1">
//                                 <FaArrowUp className="text-xs" /> Upgrade
//                             </button>
//                         </div>
//                     </div>

//                     {/* Floating Button */}
//                     {/* <button className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-white text-primary hover:bg-secondary font-semibold px-5 py-2 rounded-full shadow-lg transition-all flex items-center gap-1">
//                         <FaArrowUp className="text-xs" /> Upgrade
//                     </button> */}
//                 </div>
//             </div>
//         </div>
//     );

//     return (
//         <Layout>
//             <div className="min-h-screen  p-6">
//                 {/* New User Card */}
//                 {userData?.userType === "admin" && <UserCard />  }


//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-6">
//                     {/* KPI 1 */}
//                     <KPICard
//                         icon={FiUsers}
//                         title="No. of customers"
//                         value="1,248"
//                     />
//                     <KPICard
//                         icon={PiFlowArrow}
//                         title="No. of flows"
//                         value="4"
//                     />

//                     {/* KPI 2 */}
//                     <KPICard
//                         icon={IoIosSpeedometer}
//                         title="Average response time"
//                         value="2.4s"
//                     />

//                     {/* KPI 3 */}
//                     <KPICard
//                         icon={TbArrowBounce}
//                         title="Bounce rate"
//                         value="18%"
//                     />

//                     {/* KPI 4 */}
//                     <KPICard
//                         icon={MdOutlineTimelapse}
//                         title="Avg conversation duration"
//                         value="3m 42s"
//                     />

//                     {/* KPI 5 */}
//                     <KPICard
//                         icon={BiConversation}
//                         title="No. of conversations"
//                         value="2,156"
//                     />
//                 </div>
//                 <div className='p-6 rounded-xl shadow-sm border border-accent mb-6'>
//                     <AgCharts options={options} />
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                     <div className="bg-white p-4 rounded-sm shadow-md h-80">
//                         <h2 className="text-xl font-semibold text-[#1A5276] mb-4">Conversation Trends</h2>
//                         <div className="h-64">
//                             <Line data={lineChartData} options={chartOptions} />
//                         </div>
//                     </div>
//                     <div className="bg-white p-4 rounded-sm shadow-md h-80">
//                         <h2 className="text-xl font-semibold text-[#1A5276] mb-4">Channel Breakdown</h2>
//                         <div className="h-64">
//                             <Pie data={pieChartData} options={chartOptions} />
//                         </div>
//                     </div>
//                 </div>
//                 <div className="bg-white p-4 rounded-sm shadow-md mb-6">
//                     <h2 className="text-xl font-semibold text-[#1A5276] mb-4">Top Queries</h2>
//                     <div className="h-64">
//                         <Bar data={barChartData} options={chartOptions} />
//                     </div>
//                 </div>
//                 {userData?.userType === "admin" && 
//                 <div className="flex flex-col md:flex-row gap-6 mb-6">
//                     <div className="md:w-1/4 bg-white rounded-sm shadow-md p-4 border border-[#48BBF9]/20">
//                         {Object.keys(appData).map((tab) => (
//                             <button
//                                 key={tab}
//                                 className={`w-full text-left px-4 py-2 mb-2 rounded-sm transition ${activeTab === tab
//                                     ? 'bg-[#1A5276] text-white'
//                                     : 'text-[#1A5276] hover:bg-[#48BBF9] hover:text-white'
//                                     }`}
//                                 onClick={() => setActiveTab(tab)}
//                             >
//                                 {appData[tab].name}
//                             </button>
//                         ))}
//                     </div>
//                     <TabContent app={appData[activeTab]} />
//                 </div>}


//             </div>
//         </Layout>
//     );
// }

// export default Dashboard;












































































// import React, { useState, useEffect } from 'react';
// import { Line, Pie, Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
// } from 'chart.js';
// // import { BiConversation, IoIosSpeedometer, TbArrowBounce, MdOutlineSupportAgent, MdOutlinePendingActions, FaRegSmile, MdAssignmentLate, FaRegFrown } from 'react-icons/fi';
// import Layout from '../components/layout';
// import { BiConversation } from 'react-icons/bi';
// import { IoIosSpeedometer } from 'react-icons/io';
// import { TbArrowBounce } from 'react-icons/tb';
// import { MdAssignmentLate, MdOutlinePendingActions, MdOutlineSupportAgent } from 'react-icons/md';
// import { FaRegFrown, FaRegSmile } from 'react-icons/fa';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title);

// // KPI Card Component
// const KPICard = ({ icon: Icon, title, value, trend }) => (
//     <div className="bg-white p-5 rounded-lg shadow-md border border-blue-200">
//         <div className="flex items-center justify-between">
//             <div className="flex items-center gap-4">
//                 <div className="bg-blue-50 p-2 rounded-full text-primary">
//                     <Icon size={24} />
//                 </div>
//                 <div className="text-base text-primary font-medium">{title}</div>
//             </div>
//             {trend !== undefined && (
//                 <span className={`text-sm ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
//                     {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
//                 </span>
//             )}
//         </div>
//         <p className="text-xl text-primary font-semibold mt-4">{value}</p>
//     </div>
// );

// // Alert Component
// const AlertCard = ({ title, message, severity }) => (
//     <div className={`p-4 rounded-lg break-words shadow-md ${severity === 'error' ? 'bg-red-100 border-red-300' : 'bg-blue-100 border-blue-300'} border mb-4`}>
//         <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
//         <p className="text-gray-700">{message}</p>
//     </div>
// );

// function Dashboard() {
//     const [alerts, setAlerts] = useState([]);
//     const userData = { userType: 'admin' }; // Mock user data

//     // Static data for dashboard
//     const staticData = {
//         chatsInitiated: 2156,
//         avgResponseTime: '1.8s',
//         abandonedRate: '12%',
//         escalationRate: '15%',
//         pendingTickets: 45,
//         csatScore: '4.2/5',
//         errorRate: '2%',
//         downRatedChats: 50,
//     };

//     // Thresholds for alerts
//     const thresholds = {
//         chatsInitiated: 2000,
//         downRatedChats: 40,
//         pendingTickets: 30,
//         pendingHours: 24,
//         escalationRate: 10,
//         errorRate: 1,
//         responseTime: 2, // seconds
//         abandonedRate: 10,
//     };

//     // Mock alerts based on thresholds
//     useEffect(() => {
//         const newAlerts = [];
//         if (staticData.chatsInitiated > thresholds.chatsInitiated) {
//             newAlerts.push({
//                 title: 'High Chat Volume Alert',
//                 message: `${staticData.chatsInitiated} chats initiated today, exceeding threshold of ${thresholds.chatsInitiated}.`,
//                 severity: 'warning',
//             });
//         }
//         if (staticData.downRatedChats > thresholds.downRatedChats) {
//             newAlerts.push({
//                 title: 'High Down-Rated Chats',
//                 message: `${staticData.downRatedChats} down-rated chats today, exceeding threshold of ${thresholds.downRatedChats}.`,
//                 severity: 'warning',
//             });
//         }
//         if (staticData.pendingTickets > thresholds.pendingTickets) {
//             newAlerts.push({
//                 title: 'Open Queries Alert',
//                 message: `${staticData.pendingTickets} unresolved tickets pending for over ${thresholds.pendingHours} hours.`,
//                 severity: 'warning',
//             });
//         }
//         if (parseFloat(staticData.escalationRate) > thresholds.escalationRate) {
//             newAlerts.push({
//                 title: 'High Escalation Rate',
//                 message: `${staticData.escalationRate} of queries escalated to human agents, above threshold of ${thresholds.escalationRate}%.`,
//                 severity: 'warning',
//             });
//         }
//         if (parseFloat(staticData.errorRate) > thresholds.errorRate) {
//             newAlerts.push({
//                 title: 'Bot Downtime & Errors',
//                 message: `Error rate is ${staticData.errorRate}, above threshold of ${thresholds.errorRate}%.`,
//                 severity: 'error',
//             });
//         }
//         if (parseFloat(staticData.avgResponseTime) < thresholds.responseTime) {
//             newAlerts.push({
//                 title: 'Response Speed Alert',
//                 message: `Average response time is ${staticData.avgResponseTime}, faster than threshold of ${thresholds.responseTime}s.`,
//                 severity: 'warning',
//             });
//         }
//         if (parseFloat(staticData.abandonedRate) > thresholds.abandonedRate) {
//             newAlerts.push({
//                 title: 'High Abandonment Rate',
//                 message: `Abandonment rate is ${staticData.abandonedRate}, above threshold of ${thresholds.abandonedRate}%.`,
//                 severity: 'error',
//             });
//         }
//         setAlerts(newAlerts);
//     }, []);

//     const lineChartData = {
//         labels: ['12AM', '3AM', '6AM', '9AM', '12PM', '3PM', '6PM', '9PM'],
//         datasets: [
//             {
//                 label: 'Chats Initiated',
//                 data: [150, 170, 200, 220, 300, 280, 250, 245],
//                 borderColor: '#1A5276',
//                 backgroundColor: 'rgba(26, 82, 118, 0.5)',
//             },
//         ],
//     };

//     const pieChartData = {
//         labels: ['Up-Rated Bot', 'Down-Rated Bot', 'Tickets Created', 'Human Involved'],
//         datasets: [
//             {
//                 data: [600, 50, 200, 300],
//                 backgroundColor: ['#1A5276', '#F87171', '#48BBF9', '#A9A9A9'],
//             },
//         ],
//     };

//     const barChartData = {
//         labels: ['Billing Issues', 'Product Queries', 'Technical Support'],
//         datasets: [
//             {
//                 label: 'Query Count',
//                 data: [400, 300, 150],
//                 backgroundColor: '#1A5276',
//             },
//         ],
//     };

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: { legend: { position: 'top' } },
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen p-6">
//                 {/* {userData.userType === 'admin' && (
//                     <div className="bg-white p-6 rounded-lg shadow-md border border-blue-200 mb-6">
//                         <h2 className="text-xl font-semibold text-primary">Admin Overview</h2>
//                         <p className="text-gray-600">Managing chatbot operations for Acme Corp</p>
//                     </div>
//                 )} */}

//                 {/* Alerts Section */}
//                 {alerts.length > 0 && (
//                     <div className="mb-6">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Critical Alerts</h2>
//                         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4a gap-5'>
//                         {alerts.map((alert, index) => (
//                                 <AlertCard key={index} {...alert} />
//                             ))}
//                             </div>
//                     </div>
//                 )}

//                 {/* KPI Cards */}
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//                     <KPICard icon={BiConversation} title="Chats Initiated" value={staticData.chatsInitiated} trend={5} />
//                     <KPICard icon={IoIosSpeedometer} title="Avg Response Time" value={staticData.avgResponseTime} trend={-2} />
//                     <KPICard icon={TbArrowBounce} title="Abandonment Rate" value={staticData.abandonedRate} trend={3} />
//                     <KPICard icon={MdOutlineSupportAgent} title="Escalation Rate" value={staticData.escalationRate} trend={1} />
//                     <KPICard icon={MdOutlinePendingActions} title="Pending Tickets" value={staticData.pendingTickets} />
//                     <KPICard icon={FaRegSmile} title="CSAT Score" value={staticData.csatScore} trend={0.5} />
//                     <KPICard icon={MdAssignmentLate} title="Error Rate" value={staticData.errorRate} trend={0.5} />
//                     <KPICard icon={FaRegFrown} title="Down-Rated Chats" value={staticData.downRatedChats} trend={2} />
//                 </div>

//                 {/* Charts */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                     <div className="bg-white p-4 rounded-lg shadow-md h-80">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Chats Initiated by Hour</h2>
//                         <div className="h-64">
//                             <Line data={lineChartData} options={chartOptions} />
//                         </div>
//                     </div>
//                     <div className="bg-white p-4 rounded-lg shadow-md h-80">
//                         <h2 className="text-xl font-semibold text-primary mb-4">Conversation Outcomes</h2>
//                         <div className="h-64">
//                             <Pie data={pieChartData} options={chartOptions} />
//                         </div>
//                     </div>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-md mb-6">
//                     <h2 className="text-xl font-semibold text-primary mb-4">Top 3 Query Topics</h2>
//                     <div className="h-64">
//                         <Bar data={barChartData} options={chartOptions} />
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// }

// export default Dashboard;







































import React, { useState, useEffect } from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
} from 'chart.js';
import Layout from '../components/layout';
import { BiConversation } from 'react-icons/bi';
import { MdOutlineSupportAgent, MdOutlineTimer } from 'react-icons/md';
import { TbArrowBounce } from 'react-icons/tb';
import { FaRegSmile } from 'react-icons/fa';
import { LiaThumbsDownSolid, LiaThumbsUpSolid } from 'react-icons/lia';
import { MdOutlineSentimentVerySatisfied } from "react-icons/md";
import { apiurl } from '../config/config';
import axios from 'axios';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title);

// KPI Card Component
const KPICard = ({ icon: Icon, title, value, trend }) => (
    <div className="bg-white p-5 rounded-lg shadow-md border border-blue-200">
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
                <div className="bg-blue-50 p-2 rounded-full text-primary">
                    <Icon size={24} />
                </div>
                <div className="text-base text-primary font-medium">{title}</div>
            </div>
            {trend !== undefined && (
                <span className={`text-sm ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
                </span>
            )}
        </div>
        <p className="text-xl text-primary font-semibold mt-4">{value}</p>
    </div>
);

// Alert Component
// const AlertCard = ({ title, message, severity }) => (
//     <div className={`p-4 rounded-lg break-words shadow-md ${severity === 'error' ? 'bg-red-100 border-red-300' : 'bg-blue-100 border-blue-300'} border mb-4`}>
//         <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
//         <p className="text-gray-700">{message}</p>
//     </div>
// );

function Dashboard() {
    // const [alerts, setAlerts] = useState([]);
    // const userData = { userType: 'admin' }; // Mock user data

    // Static data for dashboard
    const staticData = {
        thumbsUp: '27',
        thumbsDown: '12',
        engagement: '10%',
        conversionRate: '8%',
        abandonmentRate: '12%',
        csatScore: '4.2/5',
        firstContactResolution: 700,
        chatbotEngagement: { whatsapp: 1000, website: 800, instagram: 600 },
        avgResponseTime: '1.8s',
        actionSuccessRate: '85%',
        salesGenerated: { cartAdditions: 5000, productRecommendations: 3000, dealDiscovery: 2000 },
        clickThroughRate: '25%',
        humanAgentQueueTime: '5m',
        avgTicketClosureTime: '24h',
        bounceRate: '15%',
        hoursSaved: '120h',
        costSaved: '$2400',
        upRatedConversations: 600,
        downRatedConversations: 50,
        ticketsCreated: 200,
        chatVolumes: { today: 2156, monthAvg: 2000, yearAvg: 1800 },
        topQueryTopics: ['Billing Issues', 'Product Queries', 'Technical Support'],
        feedbackFillRate: '85%',
        escalationRate: '15%',
        successfulClosureTime: '2m 30s',
        errorRate: '2%',
        abandonedUsers: '12%',
        agentAnalytics: {
            currentlyServing: 10,
            totalServed: 500,
            conversationsHandled: 50,
            conversationTransfers: 20,
            timeToFirstResponse: '30s',
            usualTimeToResponse: '45s',
            conversationDuration: '10m',
        },
    };

    // Thresholds for alerts
    const thresholds = {
        engagement: 5,
        conversionRate: 5,
        abandonmentRate: 10,
        csatScore: 4,
        凭证: 4,
        firstContactResolution: 500,
        avgResponseTime: 2,
        actionSuccessRate: 80,
        clickThroughRate: 20,
        humanAgentQueueTime: 300, // 5m in seconds
        avgTicketClosureTime: 86400, // 24h in seconds
        bounceRate: 10,
        hoursSaved: 100,
        costSaved: 2000,
        upRatedConversations: 500,
        downRatedConversations: 40,
        ticketsCreated: 150,
        chatVolumes: 2000,
        feedbackFillRate: 80,
        escalationRate: 10,
        successfulClosureTime: 150, // 2m 30s in seconds
        errorRate: 1,
        abandonedUsers: 10,
        agentAnalytics: {
            currentlyServing: 15,
            totalServed: 600,
            conversationsHandled: 60,
            conversationTransfers: 30,
            timeToFirstResponse: 45,
            usualTimeToResponse: 60,
            conversationDuration: 720, // 12m in seconds
        },
    };

    // Mock alerts based on thresholds
    useEffect(() => {
        const newAlerts = [];
        if (parseFloat(staticData.engagement) < thresholds.engagement) {
            newAlerts.push({
                title: 'Low Engagement Alert',
                message: `Engagement rate is ${staticData.engagement}, below threshold of ${thresholds.engagement}%.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.conversionRate) < thresholds.conversionRate) {
            newAlerts.push({
                title: 'Low Conversion Rate Alert',
                message: `Conversion rate is ${staticData.conversionRate}, below threshold of ${thresholds.conversionRate}%.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.abandonmentRate) > thresholds.abandonmentRate) {
            newAlerts.push({
                title: 'High Abandonment Rate',
                message: `Abandonment rate is ${staticData.abandonmentRate}, above threshold of ${thresholds.abandonmentRate}%.`,
                severity: 'error',
            });
        }
        if (parseFloat(staticData.csatScore) < thresholds.csatScore) {
            newAlerts.push({
                title: 'Low CSAT Score Alert',
                message: `CSAT score is ${staticData.csatScore}, below threshold of ${thresholds.csatScore}/5.`,
                severity: 'warning',
            });
        }
        if (staticData.firstContactResolution < thresholds.firstContactResolution) {
            newAlerts.push({
                title: 'Low First Contact Resolution',
                message: `First contact resolutions are ${staticData.firstContactResolution}, below threshold of ${thresholds.firstContactResolution}.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.avgResponseTime) > thresholds.avgResponseTime) {
            newAlerts.push({
                title: 'Slow Response Time Alert',
                message: `Average response time is ${staticData.avgResponseTime}, slower than threshold of ${thresholds.avgResponseTime}s.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.actionSuccessRate) < thresholds.actionSuccessRate) {
            newAlerts.push({
                title: 'Low Action Success Rate',
                message: `Action success rate is ${staticData.actionSuccessRate}, below threshold of ${thresholds.actionSuccessRate}%.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.clickThroughRate) < thresholds.clickThroughRate) {
            newAlerts.push({
                title: 'Low Click-Through Rate',
                message: `Click-through rate is ${staticData.clickThroughRate}, below threshold of ${thresholds.clickThroughRate}%.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.humanAgentQueueTime.replace('m', '')) * 60 > thresholds.humanAgentQueueTime) {
            newAlerts.push({
                title: 'High Agent Queue Time',
                message: `Human agent queue time is ${staticData.humanAgentQueueTime}, above threshold of ${thresholds.humanAgentQueueTime / 60}m.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.avgTicketClosureTime.replace('h', '')) * 3600 > thresholds.avgTicketClosureTime) {
            newAlerts.push({
                title: 'Slow Ticket Closure',
                message: `Average ticket closure time is ${staticData.avgTicketClosureTime}, above threshold of ${thresholds.avgTicketClosureTime / 3600}h.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.bounceRate) > thresholds.bounceRate) {
            newAlerts.push({
                title: 'High Bounce Rate',
                message: `Bounce rate is ${staticData.bounceRate}, above threshold of ${thresholds.bounceRate}%.`,
                severity: 'error',
            });
        }
        if (parseFloat(staticData.hoursSaved.replace('h', '')) < thresholds.hoursSaved) {
            newAlerts.push({
                title: 'Low Hours Saved',
                message: `Hours saved are ${staticData.hoursSaved}, below threshold of ${thresholds.hoursSaved}h.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.costSaved.replace('$', '')) < thresholds.costSaved) {
            newAlerts.push({
                title: 'Low Cost Saved',
                message: `Cost saved is ${staticData.costSaved}, below threshold of ${thresholds.costSaved}$.`,
                severity: 'warning',
            });
        }
        if (staticData.upRatedConversations < thresholds.upRatedConversations) {
            newAlerts.push({
                title: 'Low Up-Rated Conversations',
                message: `Up-rated conversations are ${staticData.upRatedConversations}, below threshold of ${thresholds.upRatedConversations}.`,
                severity: 'warning',
            });
        }
        if (staticData.downRatedConversations > thresholds.downRatedConversations) {
            newAlerts.push({
                title: 'High Down-Rated Conversations',
                message: `Down-rated conversations are ${staticData.downRatedConversations}, above threshold of ${thresholds.downRatedConversations}.`,
                severity: 'warning',
            });
        }
        if (staticData.ticketsCreated > thresholds.ticketsCreated) {
            newAlerts.push({
                title: 'High Tickets Created',
                message: `Tickets created are ${staticData.ticketsCreated}, above threshold of ${thresholds.ticketsCreated}.`,
                severity: 'warning',
            });
        }
        if (staticData.chatVolumes.today > thresholds.chatVolumes) {
            newAlerts.push({
                title: 'High Chat Volume Alert',
                message: `${staticData.chatVolumes.today} chats initiated today, exceeding threshold of ${thresholds.chatVolumes}.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.feedbackFillRate) < thresholds.feedbackFillRate) {
            newAlerts.push({
                title: 'Low Feedback Fill Rate',
                message: `Feedback fill rate is ${staticData.feedbackFillRate}, below threshold of ${thresholds.feedbackFillRate}%.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.escalationRate) > thresholds.escalationRate) {
            newAlerts.push({
                title: 'High Escalation Rate',
                message: `Escalation rate is ${staticData.escalationRate}, above threshold of ${thresholds.escalationRate}%.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.successfulClosureTime.replace('m', '').replace('s', '')) * 60 > thresholds.successfulClosureTime) {
            newAlerts.push({
                title: 'Slow Closure Time',
                message: `Successful closure time is ${staticData.successfulClosureTime}, above threshold of ${thresholds.successfulClosureTime / 60}m.`,
                severity: 'warning',
            });
        }
        if (parseFloat(staticData.errorRate) > thresholds.errorRate) {
            newAlerts.push({
                title: 'High Error Rate',
                message: `Error rate is ${staticData.errorRate}, above threshold of ${thresholds.errorRate}%.`,
                severity: 'error',
            });
        }
        if (parseFloat(staticData.abandonedUsers) > thresholds.abandonedUsers) {
            newAlerts.push({
                title: 'High Abandoned Users',
                message: `Abandoned users rate is ${staticData.abandonedUsers}, above threshold of ${thresholds.abandonedUsers}%.`,
                severity: 'error',
            });
        }
        // setAlerts(newAlerts);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const engagementChartData = {
    //     labels: ['Engaged', 'Not Engaged'],
    //     datasets: [
    //         {
    //             data: [parseFloat(staticData.engagement), 100 - parseFloat(staticData.engagement)],
    //             backgroundColor: ['#1A5276', '#E0E0E0'],
    //         },
    //     ],
    // };

    // const conversionChartData = {
    //     labels: ['Converted', 'Not Converted'],
    //     datasets: [
    //         {
    //             data: [parseFloat(staticData.conversionRate), 100 - parseFloat(staticData.conversionRate)],
    //             backgroundColor: ['#F87171', '#E0E0E0'],
    //         },
    //     ],
    // };

    // const chatbotEngagementChartData = {
    //     labels: ['WhatsApp', 'Website', 'Instagram'],
    //     datasets: [
    //         {
    //             label: 'Chatbot Engagement',
    //             data: [
    //                 staticData.chatbotEngagement.whatsapp,
    //                 staticData.chatbotEngagement.website,
    //                 staticData.chatbotEngagement.instagram,
    //             ],
    //             backgroundColor: ['#34D399', '#48BBF9', '#8B5CF6'],
    //         },
    //     ],
    // };

    // const salesGeneratedChartData = {
    //     labels: ['Cart Additions', 'Product Recommendations', 'Deal Discovery'],
    //     datasets: [
    //         {
    //             data: [
    //                 staticData.salesGenerated.cartAdditions,
    //                 staticData.salesGenerated.productRecommendations,
    //                 staticData.salesGenerated.dealDiscovery,
    //             ],
    //             backgroundColor: ['#1A5276', '#F87171', '#34D399'],
    //         },
    //     ],
    // };

    // const chatVolumeChartData = {
    //     labels: ['Today', 'Month Avg', 'Year Avg'],
    //     datasets: [
    //         {
    //             label: 'Chat Volumes',
    //             data: [
    //                 staticData.chatVolumes.today,
    //                 staticData.chatVolumes.monthAvg,
    //                 staticData.chatVolumes.yearAvg,
    //             ],
    //             backgroundColor: ['#48BBF9', '#A9A9A9', '#FBBF24'],
    //         },
    //     ],
    // };

    // const csatChartData = {
    //     labels: ['Today', 'Month Avg', 'Year Avg'],
    //     datasets: [
    //         {
    //             label: 'CSAT Score',
    //             data: [
    //                 parseFloat(staticData.csatScore),
    //                 parseFloat(staticData.csatScore) - 0.2, // Mock variation
    //                 parseFloat(staticData.csatScore) - 0.3,
    //             ],
    //             backgroundColor: ['#34D399', '#A9A9A9', '#FBBF24'],
    //         },
    //     ],
    // };

    // const conversationOutcomesChartData = {
    //     labels: ['Up-Rated Bot', 'Down-Rated Bot', 'Tickets Created', 'Human Involved'],
    //     datasets: [
    //         {
    //             data: [
    //                 staticData.upRatedConversations,
    //                 staticData.downRatedConversations,
    //                 staticData.ticketsCreated,
    //                 staticData.chatbotEngagement.whatsapp + staticData.chatbotEngagement.website + staticData.chatbotEngagement.instagram - staticData.upRatedConversations - staticData.downRatedConversations - staticData.ticketsCreated,
    //             ],
    //             backgroundColor: ['#1A5276', '#F87171', '#48BBF9', '#A9A9A9'],
    //         },
    //     ],
    // };

    // const topQueryTopicsChartData = {
    //     labels: staticData.topQueryTopics,
    //     datasets: [
    //         {
    //             label: 'Query Count',
    //             data: [400, 300, 150], // Mock data
    //             backgroundColor: ['#1A5276', '#48BBF9', '#34D399'],
    //         },
    //     ],
    // };

    // const agentAnalyticsChartData = {
    //     labels: ['Currently Serving', 'Total Served', 'Conversations Handled'],
    //     datasets: [
    //         {
    //             label: 'Agent Analytics',
    //             data: [
    //                 staticData.agentAnalytics.currentlyServing,
    //                 staticData.agentAnalytics.totalServed,
    //                 staticData.agentAnalytics.conversationsHandled,
    //             ],
    //             backgroundColor: ['#8B5CF6', '#EC4899', '#FBBF24'],
    //         },
    //     ],
    // };

    // const chartOptions = {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     plugins: { legend: { position: 'top' } },
    // };

    // Aggregate all dashboard data for DownloadButton
    // const allDashboardData = (() => {
    //     const allData = [];

    //     // KPIs
    //     const kpis = [
    //         { key: 'thumbsUp', label: 'Thumbs Up', value: staticData.thumbsUp },
    //         { key: 'thumbsDown', label: 'Thumbs Down', value: staticData.thumbsDown },
    //         { key: 'engagement', label: 'Engagement %', value: staticData.engagement },
    //         { key: 'conversionRate', label: 'Conversion Rate', value: staticData.conversionRate },
    //         { key: 'abandonmentRate', label: 'Abandonment Rate', value: staticData.abandonmentRate },
    //         { key: 'csatScore', label: 'CSAT Score', value: staticData.csatScore },
    //         { key: 'firstContactResolution', label: 'First Contact Resolution', value: staticData.firstContactResolution },
    //         { key: 'avgResponseTime', label: 'Avg Response Time', value: staticData.avgResponseTime },
    //         { key: 'actionSuccessRate', label: 'Action Success Rate', value: staticData.actionSuccessRate },
    //         { key: 'clickThroughRate', label: 'Click-Through Rate', value: staticData.clickThroughRate },
    //         { key: 'humanAgentQueueTime', label: 'Human Agent Queue Time', value: staticData.humanAgentQueueTime },
    //         { key: 'avgTicketClosureTime', label: 'Avg Ticket Closure Time', value: staticData.avgTicketClosureTime },
    //         { key: 'bounceRate', label: 'Bounce Rate', value: staticData.bounceRate },
    //         { key: 'hoursSaved', label: 'Hours Saved', value: staticData.hoursSaved },
    //         { key: 'costSaved', label: 'Cost Saved', value: staticData.costSaved },
    //         { key: 'chatVolumes', label: 'Chat Volumes (Today)', value: staticData.chatVolumes.today },
    //         { key: 'feedbackFillRate', label: 'Feedback Fill Rate', value: staticData.feedbackFillRate },
    //         { key: 'escalationRate', label: 'Escalation Rate', value: staticData.escalationRate },
    //         { key: 'successfulClosureTime', label: 'Successful Closure Time', value: staticData.successfulClosureTime },
    //         { key: 'errorRate', label: 'Error Rate', value: staticData.errorRate },
    //         { key: 'abandonedUsers', label: 'Abandoned Users', value: staticData.abandonedUsers },
    //     ];

    //     kpis.forEach(kpi => {
    //         allData.push({
    //             Metric: kpi.label,
    //             Value: kpi.value,
    //         });
    //     });

    //     // Chatbot Engagement
    //     chatbotEngagementChartData.labels.forEach((label, index) => {
    //         allData.push({
    //             Metric: 'Chatbot Engagement',
    //             Label: label,
    //             Value: chatbotEngagementChartData.datasets[0].data[index],
    //         });
    //     });

    //     // Sales Generated
    //     salesGeneratedChartData.labels.forEach((label, index) => {
    //         allData.push({
    //             Metric: 'Sales Generated',
    //             Label: label,
    //             Value: salesGeneratedChartData.datasets[0].data[index],
    //         });
    //     });

    //     // Chat Volumes
    //     chatVolumeChartData.labels.forEach((label, index) => {
    //         allData.push({
    //             Metric: 'Chat Volumes',
    //             Label: label,
    //             Value: chatVolumeChartData.datasets[0].data[index],
    //         });
    //     });

    //     // CSAT Score
    //     csatChartData.labels.forEach((label, index) => {
    //         allData.push({
    //             Metric: 'CSAT Score',
    //             Label: label,
    //             Value: csatChartData.datasets[0].data[index],
    //         });
    //     });

    //     // Conversation Outcomes
    //     conversationOutcomesChartData.labels.forEach((label, index) => {
    //         allData.push({
    //             Metric: 'Conversation Outcomes',
    //             Label: label,
    //             Value: conversationOutcomesChartData.datasets[0].data[index],
    //         });
    //     });

    //     // Top Query Topics
    //     topQueryTopicsChartData.labels.forEach((label, index) => {
    //         allData.push({
    //             Metric: 'Top Query Topics',
    //             Label: label,
    //             Value: topQueryTopicsChartData.datasets[0].data[index],
    //         });
    //     });

    //     // Agent Analytics
    //     agentAnalyticsChartData.labels.forEach((label, index) => {
    //         allData.push({
    //             Metric: 'Agent Analytics',
    //             Label: label,
    //             Value: agentAnalyticsChartData.datasets[0].data[index],
    //         });
    //     });

    //     // Alerts
    //     alerts.forEach((alert, index) => {
    //         allData.push({
    //             Metric: 'Alert',
    //             Label: `Alert ${index + 1}`,
    //             Title: alert.title,
    //             Message: alert.message,
    //             Severity: alert.severity,
    //         });
    //     });

    //     return allData;
    // })();







    const [date, setDate] = useState('');
    const [dashboardData, setDashboardData] = useState(null);
    // const [loading, setLoading] = useState(true);
    // const [error, setError] = useState(null);
    // const fetchDashboardData = async () => {
    //     try {
    //         const response = await axios.post(`${apiurl}/apis/dashboardData`);
    //         setDashboardData(response?.data?.data); // Save API response to state
    //         setLoading(false);
    //     } catch (err) {
    //         console.error('Error fetching dashboard data:', err);
    //         setError(err.message);
    //         setLoading(false);
    //     }
    // }; 

    const fetchDashboardData = async (selectedDate) => {
        // setLoading(true);
        // setError(null);

        try {
            const response = await axios.post(
                `${apiurl}/apis/dashboardData`,
                selectedDate ? { date: selectedDate } : {}, // Only send if date selected
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            setDashboardData(response.data);
        } catch (err) {
            console.error('API error:', err);
            // setError(err);
        }
    };

    useEffect(() => {
        fetchDashboardData();
    }, []);
    console.log("dashboardData", dashboardData)

    const handleDateChange = (e) => {
        const selectedDate = e.target.value;
        setDate(selectedDate);
        fetchDashboardData(selectedDate);
    };

    return (
        <Layout>
            <div className="min-h-screen p-6">
                {/* <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
                    <h2 className="text-xl font-semibold text-primary">Download Dashboard Data</h2>
                    <DownloadButton
                        data={allDashboardData}
                        filename="dashboard_data"
                    />
                </div> */}
                {/* {alerts.length > 0 && (
                    <div className="mb-6">
                        <h2 className="text-xl font-semibold text-primary mb-4">Critical Alerts</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                            {alerts.map((alert, index) => (
                                <AlertCard key={index} {...alert} />
                            ))}
                        </div>
                    </div>
                )} */}
                
                <div className="bg-white p-6 flex justify-between items-center rounded-lg shadow-md border border-blue-200 mb-6">
                    <label className="block font-medium">Select Date:</label>
                    <input
                        type="date"
                        value={date}
                        onChange={handleDateChange}
                        className="border rounded px-3 py-2 text-xs"
                    />
                </div>
                {/* Billing Section */}
                {/* <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-8 rounded-xl shadow-lg mb-6 text-white">
                    <div className="flex items-center justify-between">
                        <div>
                            <h2 className="text-2xl font-bold mb-2">Billing Summary</h2>
                            <p className="text-sm opacity-80">Total cost based on chat volume</p>
                        </div>
                        <div className="text-right">
                            <p className="text-3xl font-semibold">₹{(2156 * 4).toFixed(2)}</p>
                            <p className="text-sm opacity-80">For 2156 conversations</p>
                        </div>
                    </div>
                </div> */}
                {/* KPI Cards */}
                {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                    <KPICard icon={BiConversation} title="Engagement %" value={staticData.engagement} trend={2} />
                    <KPICard icon={MdOutlineMonetizationOn} title="Conversion Rate" value={staticData.conversionRate} trend={1} />
                    <KPICard icon={FaRegSmile} title="CSAT Score" value={staticData.csatScore} trend={0.5} />
                    <KPICard icon={MdOutlineThumbUp} title="First Contact Resolution" value={staticData.firstContactResolution} trend={4} />
                    <KPICard icon={IoIosSpeedometer} title="Avg Response Time" value={staticData.avgResponseTime} trend={-2} />
                    <KPICard icon={MdOutlinePendingActions} title="Action Success Rate" value={staticData.actionSuccessRate} trend={1.5} />
                    <KPICard icon={MdOutlineExitToApp} title="Click-Through Rate" value={staticData.clickThroughRate} trend={2} />
                    <KPICard icon={MdOutlineSupportAgent} title="Human Agent Queue Time" value={staticData.humanAgentQueueTime} trend={0.5} />
                    <KPICard icon={TbArrowBounce} title="Bounce Rate" value={staticData.bounceRate} trend={2} />
                    <KPICard icon={MdOutlineHourglassEmpty} title="Hours Saved" value={staticData.hoursSaved} trend={3} />
                    <KPICard icon={MdOutlineSavings} title="Cost Saved" value={staticData.costSaved} trend={2} />
                    <KPICard icon={BiConversation} title="Chat Volumes" value={staticData.chatVolumes.today} trend={5} />
                    <KPICard icon={MdOutlineTimer} title="Successful Closure Time" value={staticData.successfulClosureTime} trend={0.5} />
                    <KPICard icon={MdAssignmentLate} title="Error Rate" value={staticData.errorRate} trend={0.5} />
                    <KPICard icon={TbArrowBounce} title="Abandoned Users" value={staticData.abandonedUsers} trend={2} />
                </div> */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-blue-200  mb-6">
                    {/* For Percentage => */}
                    <p className="block font-medium mb-6 text-primary">
                        Key Performance Indicators
                    </p>
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
                        <KPICard icon={TbArrowBounce} title="Abandonment Chats" value={dashboardData?.data?.total_abandoned_true} />
                        <KPICard icon={BiConversation} title="Total Conversations" value={dashboardData?.data?.total_conversations} />
                        <KPICard icon={LiaThumbsUpSolid} title="Thumbs Up" value={dashboardData?.data?.total_thumbs_up_true} />
                        <KPICard icon={LiaThumbsDownSolid} title="Thumbs Down" value={dashboardData?.data?.total_thumbs_down_true} />
                        <KPICard icon={MdOutlineSupportAgent} title="Escalated To Human Agent" value={dashboardData?.data?.total_escalated_to_human_true} />
                        <KPICard icon={FaRegSmile} title="Total Feedback Received" value={dashboardData?.data?.total_feedback_given_true} />
                        <KPICard icon={MdOutlineTimer} title="Total Ticket Created" value={dashboardData?.data?.total_ticket_created_true} />
                        <KPICard
                            icon={MdOutlineTimer}
                            title="Avg Closure Time"
                            value={`${Number(dashboardData?.data?.average_closure_time_minutes).toFixed(2)} min`}
                        />
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm border border-blue-200  mb-6">
                    {/* For Percentage => */}
                    <p className="block font-medium mb-6 text-primary">
                        In Percentage
                    </p>
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
                        <KPICard
                            icon={TbArrowBounce}
                            title="Abandonment Chats"
                            value={`${Number(dashboardData?.percentages?.abandoned_percentage).toFixed(2)} %`}
                        />
                        <KPICard
                            icon={LiaThumbsUpSolid}
                            title="Thumbs Up"
                            value={`${Number(dashboardData?.percentages?.thumbs_up_percentage).toFixed(2)} %`}
                        />

                        <KPICard
                            icon={LiaThumbsDownSolid}
                            title="Thumbs Down"
                            value={`${Number(dashboardData?.percentages?.thumbs_down_percentage).toFixed(2)} %`}
                        />

                        <KPICard
                            icon={MdOutlineSupportAgent}
                            title="Escalated To Human Agent"
                            value={`${Number(dashboardData?.percentages?.escalated_to_human_percentage).toFixed(2)} %`}
                        />

                        <KPICard
                            icon={FaRegSmile}
                            title="Total Feedback Received"
                            value={`${Number(dashboardData?.percentages?.feedback_given_percentage).toFixed(2)} %`}
                        />

                        <KPICard
                            icon={MdOutlineTimer}
                            title="Total Ticket Created"
                            value={`${Number(dashboardData?.percentages?.ticket_created_percentage).toFixed(2)} %`}
                        />
                        <KPICard
                            icon={MdOutlineSentimentVerySatisfied}
                            title="CSAT Score"
                            value={`${Number(dashboardData?.data?.csat_score).toFixed(2)} %`}
                        />
                    </div>

                </div>

                {/* Charts */}
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">Engagement %</h2>
                        <div className="h-64">
                            <Doughnut data={engagementChartData} options={chartOptions} />
                        </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">Conversion Rate</h2>
                        <div className="h-64">
                            <Pie data={conversionChartData} options={chartOptions} />
                        </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">Chatbot Engagement by Channel</h2>
                        <div className="h-64">
                            <Bar data={chatbotEngagementChartData} options={chartOptions} />
                        </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">Sales Generated</h2>
                        <div className="h-64">
                            <Pie data={salesGeneratedChartData} options={chartOptions} />
                        </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">Chat Volumes</h2>
                        <div className="h-64">
                            <Bar data={chatVolumeChartData} options={chartOptions} />
                        </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">CSAT Score</h2>
                        <div className="h-64">
                            <Bar data={csatChartData} options={chartOptions} />
                        </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">Conversation Outcomes</h2>
                        <div className="h-64">
                            <Pie data={conversationOutcomesChartData} options={chartOptions} />
                        </div>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-md h-80">
                        <h2 className="text-xl font-semibold text-primary mb-4">Top 3 Query Topics</h2>
                        <div className="h-64">
                            <Bar data={topQueryTopicsChartData} options={chartOptions} />
                        </div>
                    </div>
                    {userData.userType === 'admin' && (
                        <div className="bg-white p-4 rounded-lg shadow-md h-80">
                            <h2 className="text-xl font-semibold text-primary mb-4">Agent Analytics</h2>
                            <div className="h-64">
                                <Bar data={agentAnalyticsChartData} options={chartOptions} />
                            </div>
                        </div>
                    )}
                </div> */}
            </div>

        </Layout>
    );
}

export default Dashboard;